import type { SensorPickerEntry } from '../../../utils/electronicsDashboardUtils';
import { useChoosePortsToolbar } from './useChoosePortsToolbar';

/** Header toolbar for multi-port electronic sensor stream widgets (`sensor`, sensor `boolean`). */
export function useChooseSensorsToolbar({
  show,
  isHistoricMode,
  sensors,
  selectedPorts,
  onSelectedPortsChange,
  disabled,
  selectedPortsKey,
}: {
  show: boolean;
  isHistoricMode: boolean;
  sensors: readonly SensorPickerEntry[];
  selectedPorts: readonly number[];
  onSelectedPortsChange: (ports: number[]) => void;
  disabled?: boolean;
  selectedPortsKey: string;
}) {
  return useChoosePortsToolbar({
    show,
    isHistoricMode,
    entries: sensors,
    selectedPorts,
    onSelectedPortsChange,
    disabled,
    selectedPortsKey,
    chooseButtonI18nKey: 'dashboard.sensorWidget.chooseSensors',
    chooseButtonDefault: 'Choose Sensors',
    chooseAllI18nKey: 'dashboard.sensorWidget.chooseAll',
    chooseAllDefault: 'Choose all',
  });
}
